// @ts-strict-ignore
import type { MatrixModel } from 'flow/store/engine/types';
import { MatrixAxisDataType, MatrixAxisOrder } from './types';

export const AXIS_HIGH_UNBOUNDED_NUMBER = Number.MAX_VALUE;
export const AXIS_LOW_UNBOUNDED_NUMBER = -Number.MAX_VALUE;

export const DEFAULT_NULL_X_AXIS: MatrixModel['axis']['x'] = {
  order: null,
  axisHeaderDataType: null,
  axisHeader: [],
};

export const INIT_RANGE_AXIS: MatrixModel['axis']['x' | 'y'] = {
  order: MatrixAxisOrder.ASC,
  axisHeaderDataType: MatrixAxisDataType.NUMBER,
  axisHeader: [null, AXIS_HIGH_UNBOUNDED_NUMBER],
};

export const INIT_EXACT_AXIS: MatrixModel['axis']['x' | 'y'] = {
  order: null,
  axisHeaderDataType: MatrixAxisDataType.STRING,
  axisHeader: [null],
};

export const DEFAULT_INIT_AXIS = INIT_RANGE_AXIS;
